import React from "react";
import Image from "../elements/Image";
const TestimonialItem = ({data}) => {
 
  return (
    <div className="rounded-2xl overflow-hidden bg-white">
        {data?.image && (
            <div className="w-full aspect-[5/3] overflow-hidden">
                <Image
                    src={data?.image}
                    classes={"object-cover hover:scale-105 transition-all duration-300"}
                />
            </div>
        )}
        
        <div className="px-4 xl:px-8 pt-4 pb-10 xl:pb-14 space-y-4 xl:space-y-6 2xl:space-y-8">
            {data?.description && (
                <div className="text-deep-purple text-base xl:text-lg">{data?.description}</div>
            )}
            {data?.name && data?.event && (
              <div className="text-right text-deep-purple text-base xl:text-lg font-bold capitalize">{data?.name}, {data?.event}</div>
            )}
            
        </div>
    </div>
  );
};

export default TestimonialItem;
